import { render, staticRenderFns } from "./salesPerson.vue?vue&type=template&id=50cc2f2a&"
import script from "./salesPerson.vue?vue&type=script&lang=js&"
export * from "./salesPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports